/**
 * Decide si Ancho/Largo item deben seguir a las dimensiones del material (COTI-502).
 *
 * El campo es editable, así que en el modelo se ven iguales dos cosas distintas: un valor que
 * autocompletamos y uno que tipeó el usuario. La única forma de distinguirlas es recordar qué
 * valor pusimos la última vez:
 *
 *  - vacío, o igual al último autocompletado  → sigue al material, se actualiza
 *  - distinto                                 → lo editó el usuario, no se toca
 *
 * Al abrir un documento guardado no hay registro previo, así que un valor existente cuenta
 * como manual y se respeta: no se puede saber si se autocompletó o se escribió, y pisar un
 * dato cargado sería peor que no actualizarlo.
 *
 * @param {object} params
 * @param {number|null} params.anchoItem Valor actual en el elemento.
 * @param {number|null} params.largoItem
 * @param {number|null} params.anchoMaterial Dimensión del material seleccionado.
 * @param {number|null} params.largoMaterial
 * @param {{ancho: number|null, largo: number|null}} params.autocompletado Último valor puesto
 *   automáticamente.
 * @returns {{hayCambio: boolean, anchoItem: number|null, largoItem: number|null,
 *   autocompletado: {ancho: number|null, largo: number|null}}}
 */
export function resolverDimensionesItem({
  anchoItem,
  largoItem,
  anchoMaterial,
  largoMaterial,
  autocompletado = { ancho: null, largo: null },
}) {
  const sigueAlMaterial = (valorActual, ultimoAuto) =>
    !Number(valorActual) || Number(valorActual) === Number(ultimoAuto);

  const resultado = {
    hayCambio: false,
    anchoItem,
    largoItem,
    autocompletado: { ...autocompletado },
  };

  if (
    Number(anchoMaterial) > 0 &&
    Number(anchoItem) !== Number(anchoMaterial) &&
    sigueAlMaterial(anchoItem, autocompletado.ancho)
  ) {
    resultado.anchoItem = Number(anchoMaterial);
    resultado.autocompletado.ancho = Number(anchoMaterial);
    resultado.hayCambio = true;
  }

  if (
    Number(largoMaterial) > 0 &&
    Number(largoItem) !== Number(largoMaterial) &&
    sigueAlMaterial(largoItem, autocompletado.largo)
  ) {
    resultado.largoItem = Number(largoMaterial);
    resultado.autocompletado.largo = Number(largoMaterial);
    resultado.hayCambio = true;
  }

  return resultado;
}
